import { atom } from 'jotai';
import { pendingQueue } from 'shared/utils/pending-queue';
import { safeAtomFamily } from 'shared/utils/safe-atom-family';

export interface IArticleGPTCommentItem {
  authorName: string;
  comment: string;
}

export interface IArticleGPTInfo {
  title: string;
  description: string;
  supplements: string;
  comments?: IArticleGPTCommentItem[];
}

export type IArticleGPTInfoKey = Exclude<keyof IArticleGPTInfo, 'comments'>;

export const $ArticleGPTInfoStore = atom<any>({});

export const $ArticleGPTInfo = safeAtomFamily((groupId: string) => {
  const a = atom<IArticleGPTInfo | Promise<IArticleGPTInfo>, [IArticleGPTInfo | Promise<IArticleGPTInfo>], void>(
    (get) => {
      const data = get($ArticleGPTInfoStore)[groupId];
      if (!data) {
        // eslint-disable-next-line @typescript-eslint/no-throw-literal
        throw new Promise((resolve) => pendingQueue.push(() => resolve('$ArticleTDK placeholder')));
      }
      return data;
    },
    (get, set, newArticle) => {
      const old = get($ArticleGPTInfoStore);
      set($ArticleGPTInfoStore, { ...old, [groupId]: newArticle });
    },
  );

  a.debugLabel = `$ArticleGPTInfo+${encodeURIComponent(groupId)}`;

  return a;
});
